import { Component, Input } from '@angular/core';
import { SoTabsBaseComponent } from '../../so-tabs-base.component';
import { Tab } from '@shared/interfaces/nav-bar-ia.interfaces';

@Component({
  selector: 'app-so-tabs-simple',
  templateUrl: './so-tabs-simple.component.html',
  styleUrl: '../../so-tabs-base.component.scss'
})
export class SoTabsSimpleComponent extends SoTabsBaseComponent {
  @Input() queryParams: any = {}; // Reemplazo del tokenService
  @Input() useToken: boolean = true;
  @Input() isUploading: boolean = true;
  @Input() isUploadingTextFile: boolean = true;
  @Input() token: string = '';

  constructor(){
    super();
  }
  getColortab(index: number, tab: Tab): string{
    return index === 0 ? 'FB' : index == 1 ? 'WHATS' : index == 2 ? 'SMS' : tab.cardColor ? tab.cardColor : 'FB';
  }
}
